export default {
    SetActiveDisplay(context, val){
      context.commit('ActiveDisplay', val);  
    },
}
